import { render, staticRenderFns } from "./KqtScheduleTypeTeacher.vue?vue&type=template&id=89fea606"
import script from "./KqtScheduleTypeTeacher.vue?vue&type=script&lang=js"
export * from "./KqtScheduleTypeTeacher.vue?vue&type=script&lang=js"
import style0 from "./KqtScheduleTypeTeacher.vue?vue&type=style&index=0&id=89fea606&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports